import { useEffect } from "react";

import { useRootStore } from "store";
import { useIsMobile } from "hooks/use-is-mobile";
import { InboxReplyContextProvider } from "app/store/InboxReplyContext";
import InboxDesktopLayout from "./desktop";
import InboxMobileLayout from "./mobile";
import { useRequiredCustomerId } from "hooks/use-customer-id";

import "./Inbox.scss";

export default function Inbox() {
  const isMobile = useIsMobile();
  const customerId = useRequiredCustomerId();

  const { fetchMyThreads, fetchAllThreads, fetchSentMessages } = useRootStore(
    (state) => state.inbox
  );
  const { fetchArchiveFolders } = useRootStore((s) => s.archive);

  useEffect(() => {
    const loadInbox = async () => {
      try {
        await Promise.all([
          fetchMyThreads(customerId),
          fetchAllThreads(customerId),
          fetchSentMessages(customerId),
          fetchArchiveFolders(customerId)
        ]);
      } catch (error) {
        console.log("Failed to load inbox:", error);
      }
    };

    loadInbox();
  }, [
    customerId,
    fetchMyThreads,
    fetchAllThreads,
    fetchSentMessages,
    fetchArchiveFolders
  ]);

  return (
    <InboxReplyContextProvider>
      {isMobile ? <InboxMobileLayout /> : <InboxDesktopLayout />}
    </InboxReplyContextProvider>
  );
}
